import { createContext } from 'react';
import { Outlet } from '~/api';
import { GetOutletsQuery } from '~/generated/hooks';

export type CacheContextProps = {
  /**
   * Cached outlets data
   */
  outlets: {
    data?: GetOutletsQuery;
    isLoading: boolean;
    refetch: () => Promise<any>;
  };
  /**
   * Get outlet name by ID
   */
  getOutletById: (id?: string) => Outlet | undefined;
};

export const CacheContext = createContext<CacheContextProps>({
  outlets: {
    data: undefined,
    isLoading: false,
    refetch: async () => {},
  },
  getOutletById: () => undefined,
}); 